import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useDuplicateCurriculum = ({
  onSuccess,
  onError
}: {
  onSuccess?: ({
    newCurriculumId,
    oldCurriculumId
  }: {
    newCurriculumId: string
    oldCurriculumId: string
  }) => void
  onError?: (curriculumId: string) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: ({ curriculumId }: { curriculumId: string }) =>
      httpService.panel.panelCurriculumsDuplicateCreate(curriculumId),
    onSuccess: (data, variables) =>
      onSuccess?.({
        newCurriculumId: data.id,
        oldCurriculumId: variables.curriculumId
      }),
    onError: (_error, variables) => onError?.(variables.curriculumId)
  })

export default useDuplicateCurriculum
